<template>
  <div v-if="props.editable">
    <!-- Single InputText for non-multiple mode -->
    <InputText v-if="!props.multiple" v-model="model[0]" spellcheck="false" />

    <!-- Chips input for multiple mode -->
    <ul v-else class="chip-container" @click.stop="focusInput">
      <!-- Render existing chips -->
      <li v-for="(value, index) in model" :key="index" class="chip" @click.stop>
        {{ value }}
        <CloseButton class="ml-2" @close="removeChip(index)"></CloseButton>
      </li>

      <!-- Input for adding new chips -->
      <li class="align-items-stretch" style="display: none">
        <InputText
          v-model="currentInput"
          spellcheck="false"
          class="new-chip-input outline-0 min-w-10"
          placeholder="' , ' or Enter to add"
          @keydown.enter.prevent="
            currentInput += ',';
            splitChips();
          "
          @keydown.delete="backspaceHandler"
          @input="splitChips"
          @focusout="
            currentInput += ',';
            splitChips();
            unfocusInput($event);
          "
        />
      </li>
    </ul>
  </div>
  <div v-else>
    <b v-if="!props.multiple">
      {{ model[0] }}
    </b>
    <ul v-else class="chip-container !p-0 !min-w-fit">
      <li v-for="(value, index) in model" :key="index" class="chip">
        {{ value }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { defineModel, defineProps, ref } from "vue";
import InputText from "primevue/inputtext";
import CloseButton from "@/components/closeButton.vue";

// Define props and model
const props = defineProps({
  multiple: { type: Boolean, default: false },
  editable: { type: Boolean, default: true },
});
const model = defineModel({ required: true });

// Reactive state for the current input value
const currentInput = ref("");

function focusInput(event) {
  const inp = event.target.querySelector(".new-chip-input");
  inp.parentNode.style.display = "flex";
  inp.focus();
}

function unfocusInput(event) {
  event.target.parentNode.style.display = "none";
}

function backspaceHandler(event) {
  if (currentInput.value === "") {
    removeChip(model.value.length - 1);
    event.preventDefault();
  }
}

// Methods
function splitChips() {
  // Split input by delimiters (comma, space)
  const parts = currentInput.value.split(/[,]+/);
  currentInput.value = parts.pop(); // Keep the unfinished part in the input
  model.value.push(
    ...parts.filter((part) => part.trim() !== "").map((part) => part.trim())
  ); // Add valid parts as chips
}

function removeChip(index) {
  model.value = model.value.filter((_, i) => i !== index);
}
</script>

<style scoped>
.chip-container {
  @apply bg-surface-200 dark:bg-surface-700 rounded-xl p-[0.35rem] flex gap-2 flex-wrap cursor-text
  min-w-[160px] min-h-[1.9rem] max-h-48 max-w-80 overflow-auto;
}

.p-inputtext {
  --p-textarea-padding-x: 0.7rem;
  --p-textarea-padding-y: 0.2rem;
  height: 1.9rem;
  min-height: 1.9rem;
  min-width: 10rem;
  border: 0;
  resize: both;
}
</style>
